export const pillStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  padding: '2px 8px',
  borderRadius: '12px',
  backgroundColor: 'action.selected',
  color: 'text.secondary',
};

export const pillCountStyles = {
  color: 'inherit',
};
